import {
  Button,
  IconText,
  Image,
  ModalLayout,
  ConfirmationBox,
} from "@wac-ui-dashboard/wac_component_library";
import useUploads from "./useUploads";
import { SelectFromThumbnails } from "../../../MenuThumbnails/ThumbnailPicker";
import { limitStrLength } from "../../../../utils/functions/table";
import Style from "../mediaVideoForm.module.scss";
import { ProfileCard } from "../../../Global/ProfileCard";
import { clearConfig } from "dompurify";

const Uploads = ({
  getFieldError,
  isEditData,
  isLoading,
  formik,
  profilefileInputRef,
  handleListThumbnailImage,
  handleTitleImage,
  handleBannerImage,
  handleBasicThumnailImage,
  imageCoverPreview,
  imageTitleImagePreview,
  imageBannerPreview,
  basicThumbnailImageCoverPreview,
  handlevideo,
  uploadState,
  show,
  closeModal,
  fieldName,
  setShow,
  setImageCoverPreview,
  setImageTitleImagePreview,
  setImageBannerPreview,
  setBasicThumbnailImageCoverPreview,
  cropData,
  formikImage,
  setFormikImage,
  currentFormData,
  handleClick,
  setImageVerticalThumbnailPreview,
  handleVerticalImage,
  imageVerticalThumbnailPreview,
  showAlertModal,
  setShowAlertModal,
  closeAlertModal,
  sumbitAlert,
}) => {
  const { handleCloseModal } = useUploads({
    formik,
    uploadState,
    setShowAlertModal
  });
  return (
    <div className={`pro-w-100`}>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Title Image [3:2]
        </label>
        <div className="input-drag">
          <input
            type="file"
            placeholder="placeholder"
            accept=".png"
            ref={profilefileInputRef}
            className={`pro-input lg ${
              getFieldError("title_image") && " error"
            }`}
            id="title_image"
            name="title_image"
            onBlur={formik.handleBlur("title_image")}
            onChange={(e) => handleTitleImage(e)}
            onClick={handleClick}
          />
          <span className="input-drag-box">
            <IconText
              title={
                formik?.values?.title_image?.name !== undefined &&
                isEditData &&
                formik?.values?.title_image?.name
                  ? limitStrLength(formik?.values?.title_image?.name, 30)
                  : isEditData && formik?.values?.title_image
                  ? limitStrLength(formik?.values?.title_image ?? "", 30)
                  : !isEditData && formik?.values?.title_image?.name
                  ? limitStrLength(formik?.values?.title_image?.name ?? "", 30)
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {getFieldError("title_image") && (
            <span className="error-text">{getFieldError("title_image")}</span>
          )}
        </div>
        <p className="pro-mb-0 pro-font-xs pro-mt-1">(file of type: png.)</p>
        {/* pick an image from Menu Thumbnails instead of uploading one */}
        <SelectFromThumbnails
          mediaType="video"
          ratio={{ width: 3, height: 2 }}
          label="Title Image"
          fieldName="title_image"
          formik={formik}
          setPreview={setImageTitleImagePreview}
        />
      </div>
      <div className={`col-2 pro-my-2`}>
        <div className={`${Style.root_image_inner}`}>
          <Image
            width={100}
            height={100}
            src={imageTitleImagePreview}
            alt={`title_image`}
          />
        </div>
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Banner Image [4:5]
        </label>
        <div className="input-drag">
          <input
            type="file"
            placeholder="placeholder"
            accept=".jpeg, .jpg , .png"
            ref={profilefileInputRef}
            className={`pro-input lg ${
              getFieldError("banner_image") && " error"
            }`}
            id="banner_image"
            name="banner_image"
            onBlur={formik.handleBlur("banner_image")}
            onChange={(e) => handleBannerImage(e)}
            onClick={handleClick}
          />
          <span className="input-drag-box">
            <IconText
              title={
                formik?.values?.banner_image?.name !== undefined &&
                isEditData &&
                formik?.values?.banner_image?.name
                  ? limitStrLength(formik?.values?.banner_image?.name, 30)
                  : isEditData && formik?.values?.banner_image
                  ? limitStrLength(formik?.values?.banner_image ?? "", 30)
                  : !isEditData && formik?.values?.banner_image?.name
                  ? limitStrLength(formik?.values?.banner_image?.name ?? "", 30)
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {getFieldError("banner_image") && (
            <span className="error-text">{getFieldError("banner_image")}</span>
          )}
        </div>
        <p className="pro-mb-0 pro-font-xs pro-mt-1">
          (file of type: jpeg, png, jpg, gif.)
        </p>
        {/* pick an image from Menu Thumbnails instead of uploading one */}
        <SelectFromThumbnails
          mediaType="video"
          ratio={{ width: 4, height: 5 }}
          label="Banner Image"
          fieldName="banner_image"
          formik={formik}
          setPreview={setImageBannerPreview}
        />
      </div>
      <div className={`col-2 pro-my-2`}>
        <div className={`${Style.root_image_inner}`}>
          <Image
            width={100}
            height={100}
            src={imageBannerPreview}
            alt={`banner_image`}
          />
        </div>
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          List Thumbnail [16:9]*
        </label>
        <div className="input-drag">
          <input
            type="file"
            placeholder="placeholder"
            accept=".jpeg, .jpg , .png"
            ref={profilefileInputRef}
            className={`pro-input lg ${
              getFieldError("list_thumbnail") && " error"
            }`}
            id="list_thumbnail"
            name="list_thumbnail"
            onBlur={formik.handleBlur("list_thumbnail")}
            onChange={(e) => handleListThumbnailImage(e)}
            onClick={handleClick}
          />
          <span className="input-drag-box">
            <IconText
              title={
                formik?.values?.list_thumbnail?.name !== undefined &&
                isEditData &&
                formik?.values?.list_thumbnail?.name
                  ? limitStrLength(formik?.values?.list_thumbnail?.name, 30)
                  : isEditData && formik?.values?.list_thumbnail
                  ? limitStrLength(formik?.values?.list_thumbnail ?? "", 30)
                  : !isEditData && formik?.values?.list_thumbnail?.name
                  ? limitStrLength(
                      formik?.values?.list_thumbnail?.name ?? "",
                      30
                    )
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {getFieldError("list_thumbnail") && (
            <span className="error-text">
              {getFieldError("list_thumbnail")}
            </span>
          )}
        </div>
        <p className="pro-mb-0 pro-font-xs pro-mt-1">
          (file of type: jpeg, png, jpg, gif.)
        </p>
        {/* pick an image from Menu Thumbnails instead of uploading one */}
        <SelectFromThumbnails
          mediaType="video"
          ratio={{ width: 16, height: 9 }}
          label="List Thumbnail"
          fieldName="list_thumbnail"
          formik={formik}
          setPreview={setImageCoverPreview}
        />
      </div>
      <div className={`col-2 pro-my-2`}>
        <div className={`${Style.root_image_inner}`}>
          <Image
            width={100}
            height={100}
            src={imageCoverPreview}
            alt={`list_thumbnail`}
          />
        </div>
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Basic Thumbnail [1:1]*
        </label>
        <div className="input-drag">
          <input
            type="file"
            placeholder="placeholder"
            accept=".jpeg, .jpg , .png"
            ref={profilefileInputRef}
            className={`pro-input lg ${
              getFieldError("basic_thumbnail") && " error"
            }`}
            id="basic_thumbnail"
            name="basic_thumbnail"
            onBlur={formik.handleBlur("basic_thumbnail")}
            onChange={(e) => handleBasicThumnailImage(e)}
            onClick={handleClick}
          />
          <span className="input-drag-box">
            <IconText
              title={
                formik?.values?.basic_thumbnail?.name !== undefined &&
                isEditData &&
                formik?.values?.basic_thumbnail?.name
                  ? limitStrLength(formik?.values?.basic_thumbnail?.name, 30)
                  : isEditData && formik?.values?.basic_thumbnail
                  ? limitStrLength(formik?.values?.basic_thumbnail ?? "", 30)
                  : !isEditData && formik?.values?.basic_thumbnail?.name
                  ? limitStrLength(
                      formik?.values?.basic_thumbnail?.name ?? "",
                      30
                    )
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {getFieldError("basic_thumbnail") && (
            <span className="error-text">
              {getFieldError("basic_thumbnail")}
            </span>
          )}
        </div>
        <p className="pro-mb-0 pro-font-xs pro-mt-1">
          (file of type: jpeg, png, jpg, gif.)
        </p>
        {/* pick an image from Menu Thumbnails instead of uploading one */}
        <SelectFromThumbnails
          mediaType="video"
          ratio={{ width: 1, height: 1 }}
          label="Basic Thumbnail"
          fieldName="basic_thumbnail"
          formik={formik}
          setPreview={setBasicThumbnailImageCoverPreview}
        />
      </div>
      <div className={`col-2 pro-my-2`}>
        <div className={`${Style.root_image_inner}`}>
          <Image
            width={100}
            height={100}
            src={basicThumbnailImageCoverPreview}
            alt={`basic_thumbnail`}
          />
        </div>
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Vertical Thumbnail [3:4]*
        </label>
        <div className="input-drag">
          <input
            type="file"
            placeholder="placeholder"
            ref={profilefileInputRef}
            className={`pro-input lg ${
              getFieldError("vertical_thumbnail") && " error"
            }`}
            id="vertical_thumbnail"
            name="vertical_thumbnail"
            onBlur={formik.handleBlur("vertical_thumbnail")}
            onChange={(e) => handleVerticalImage(e)}
            onClick={handleClick}
          />
          <span className="input-drag-box">
            <IconText
              title={
                formik?.values?.vertical_thumbnail?.name ||
                (formik?.values?.vertical_thumbnail?.[0]?.name !== undefined &&
                  isEditData &&
                  formik?.values?.vertical_thumbnail?.name) ||
                formik?.values?.vertical_thumbnail?.[0]?.name
                  ? limitStrLength(
                      formik?.values?.vertical_thumbnail?.name ||
                        formik?.values?.vertical_thumbnail?.[0]?.name,
                      30
                    )
                  : isEditData && formik?.values?.vertical_thumbnail
                  ? limitStrLength(formik?.values?.vertical_thumbnail ?? "", 30)
                  : (!isEditData && formik?.values?.vertical_thumbnail?.name) ||
                    formik?.values?.vertical_thumbnail?.[0]?.name
                  ? limitStrLength(
                      (formik?.values?.vertical_thumbnail?.name ||
                        formik?.values?.vertical_thumbnail?.[0]?.name) ??
                        "",
                      30
                    )
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {getFieldError("vertical_thumbnail") && (
            <span className="error-text">{getFieldError("vertical_thumbnail")}</span>
          )}
        </div>
        <p className="pro-mb-0 pro-font-xs pro-mt-1">(file of type: jpeg, png, jpg, gif.)</p>
        {/* pick an image from Menu Thumbnails instead of uploading one */}
        <SelectFromThumbnails
          mediaType="video"
          ratio={{ width: 3, height: 4 }}
          label="Vertical Thumbnail"
          fieldName="vertical_thumbnail"
          formik={formik}
          setPreview={setImageVerticalThumbnailPreview}
        />
      </div>
      <div className={`col-2 pro-my-2`}>
        <div className={`${Style.root_image_inner}`}>
          <Image
            width={100}
            height={100}
            src={imageVerticalThumbnailPreview}
            alt={`vertical_thumbnail`}
          />
        </div>
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Video*
        </label>
        <div className="input-drag">
          <input
            type="file"
            placeholder="placeholder"
            accept=".mp4"
            ref={profilefileInputRef}
            className={`pro-input ${
              formik.errors.video && formik.touched.video && " error"
            }`}
            id="video"
            name="video"
            onBlur={formik.handleBlur("video")}
            onChange={(e) => handlevideo(e)}
            disabled={uploadState?.isUploading}
          />
           <span className="input-drag-box">
          {uploadState?.isUploading ? (
            <div className={Style.loader_root} style={{
              '--offset' : `${270 * (1 - uploadState?.progress / 100)}px`,
              '--color' : `${25 + ((120 - 25) * (uploadState?.progress / 100))}`
            }}>
              <svg  role="progressbar" width="200" height="200" viewBox="0 0 100 100" aria-valuemin="0" aria-valuemax="100" aria-valuenow="75">
                <circle cx="50%" cy="50%" r="42" shapeRendering="geometricPrecision" className="pie-circle-1" fill="none" strokeWidth="10" strokeDashoffset="66" strokeDasharray="306" stroke="#00a1ff" data-angel="75">
                </circle>
                <text className="pie-text-1" x="50%" y="50%" fill="#000" textAnchor="middle" dy="0.35em" fontSize="1.6rem" fontWeight="400">
                  <tspan className="pie-percent-1">{uploadState?.progress}</tspan><tspan className="pie-unit-1">%</tspan>
                </text>
              </svg>
            </div> // Loader displayed here
          ) : (
            <IconText
              title={
                formik.values.video ? (
                  typeof formik.values.video === "string" ? (
                    limitStrLength(formik.values.video, 50) // Display Vimeo URL
                  ) : formik.values.video[0]?.name ? (
                    limitStrLength(formik.values.video[0]?.name, 30) // Display file name
                  ) : (
                    "Drop files to attach or browse"
                  )
                ) : (
                  "Drop files to attach or browse"
                )
              }
            />
          )}
        </span>
          {formik.touched.video && formik.errors.video && !uploadState.isUploading && (
            <span className="error-text">{formik.errors.video}</span>
          )}
        </div>
        <p className="pro-mb-0 pro-font-xs pro-mt-1">
          (file of type: mp4, ogx, oga, ogv, ogg, webm, mkv, mov.)
        </p>
      </div>

      {formikImage && (
        <ModalLayout backdrop="static" show={show} handleClose={closeModal}>
          <ProfileCard
            setShow={setShow}
            fieldName={fieldName}
            formik={formik}
            data={formikImage}
            handleClose={closeModal}
            setImageCoverPreview={setImageCoverPreview}
            setImageTitleImagePreview={setImageTitleImagePreview}
            setImageVerticalThumbnailPreview={setImageVerticalThumbnailPreview}
            setImageBannerPreview={setImageBannerPreview}
            setBasicThumbnailImageCoverPreview={
              setBasicThumbnailImageCoverPreview
            }
            cropData={cropData}
            setFormikImage={setFormikImage}
          />
        </ModalLayout>
      )}

      <div className="col-12 pro-mt-4 pro-d-flex pro-justify-end">
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={() => handleCloseModal()}
          type="button"
        >
          Cancel
        </Button>

        <Button
          className={"pro-btn-primary lg pro-mx-3"}
          type="submit"
          disabled={isLoading}
        >
          {isEditData ? "Update" : "Create"}
        </Button>
      </div>
       <ModalLayout centered show={showAlertModal} handleClose={closeAlertModal}>
              <div className="pro-m-5">
                <ConfirmationBox
                  title={`A video upload is in progress. Closing will stop the upload. Do you want to proceed?`}
                  isRight={true}
                  cancelText={`Cancel`}
                  submitText={`Okay`}
                  submitAction={sumbitAlert}
                  cancelAction={closeAlertModal}
                >
                  ConfirmationBox
                </ConfirmationBox>
              </div>
            </ModalLayout>
    </div>
  );
};
export default Uploads;
